'use client';

import { useNetworkStatus } from '@/hooks/useNetworkStatus';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { WifiOff, Wifi } from 'lucide-react';

export function OfflineIndicator() {
  const { isOnline } = useNetworkStatus();

  if (isOnline) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50">
      <Alert variant="destructive" className="rounded-none border-0">
        <WifiOff className="h-4 w-4" />
        <AlertDescription className="font-medium">
          Actualmente está desconectado. Algunas características podrían no estar disponibles.
        </AlertDescription>
      </Alert>
    </div>
  );
}

export function NetworkStatusIndicator() {
  const { isOnline } = useNetworkStatus();

  return (
    <div className="flex items-center space-x-1">
      {isOnline ? (
        <span title="En línea">
          <Wifi className="h-4 w-4 text-green-500" />
        </span>
      ) : (
        <span title="Desconectado">
          <WifiOff className="h-4 w-4 text-red-500" />
        </span>
      )}
      <span className="text-xs text-gray-500 hidden sm:inline">
        {isOnline ? 'En línea' : 'Desconectado'}
      </span>
    </div>
  );
}
